import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import OwnerCanConfirmBookingModal from '../owner-can-confirm-booking-modal/OwnerCanConfirmBookingModal'
import DeclineBookingModal from '../../decline-booking-modal/DeclineBookingModal'
import OwnerCurrentActionFooterContainer from '../../OwnerCurrentActionFooterContainer'
import { CompanyInformationClientProposalFragment } from '../../../../../../../../lib/graphql'
import { IProposalInteractionsProps } from '../../../../../../../organisms/proposal/Proposal'
import PingPongButton from '../../../../../../../organisms/proposal/proposal-cta/buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../../../../../../organisms/proposal/proposal-cta/utils/ping-pong-button-type.enum.ts'

const OwnerCanConfirmBookingFooter = ({
  ownerActions,
  clientProposal,
}: {
  ownerActions: IProposalInteractionsProps['ownerActions']
  clientProposal: CompanyInformationClientProposalFragment
}) => {
  const [isDeclineBookingModalOpen, setIsDeclineBookingModalOpen] =
    useState(false)
  const [isConfirmBookingModalOpen, setIsConfirmBookingModalOpen] =
    useState(false)

  const ownerDeclinedBooking = ownerActions?.ownerDeclinedBooking
  const ownerConfirmedBooking = ownerActions?.ownerConfirmedBooking

  if (!ownerDeclinedBooking || !ownerConfirmedBooking) {
    return null
  }

  return (
    <OwnerCurrentActionFooterContainer>
      <PingPongButton
        dataTestId='accept-booking-button'
        label={
          <FormattedMessage
            id='ui.ownerCurrentAction.canConfirmBooking.confirm.button.label'
            defaultMessage='Accepter la réservation'
          />
        }
        type={PingPongButtonTypeEnum.CONFIRM}
        onClick={() => setIsConfirmBookingModalOpen(true)}
      />
      <PingPongButton
        label={
          <FormattedMessage
            id='ui.ownerCurrentAction.canConfirmBooking.decline.button.label'
            defaultMessage='Refuser la réservation'
          />
        }
        type={PingPongButtonTypeEnum.DECLINED_BY_OWNER}
        onClick={() => setIsDeclineBookingModalOpen(true)}
      />

      {isDeclineBookingModalOpen && (
        <DeclineBookingModal
          isOpenModal={isDeclineBookingModalOpen}
          setIsOpenModal={setIsDeclineBookingModalOpen}
          ownerDeclinedBooking={ownerDeclinedBooking}
        />
      )}

      {isConfirmBookingModalOpen && (
        <OwnerCanConfirmBookingModal
          clientProposal={clientProposal}
          isOpen={isConfirmBookingModalOpen}
          setIsOpen={setIsConfirmBookingModalOpen}
          ownerConfirmedBooking={ownerConfirmedBooking}
        />
      )}
    </OwnerCurrentActionFooterContainer>
  )
}

export default OwnerCanConfirmBookingFooter
